export class ResetPassword {
    id: number = 0;
    email!: string;
    token!: string;
    active: boolean = false;
    userId: number = 0;;
    newPassword!: string;
    isUpdate: boolean = false;
    used: boolean = false;
    expirationDate: Date = new Date();
}